var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedalClub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 21,
    viewBox: "0 0 14 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4132 20.6093L7.0002 18.4572L3.58716 20.6093V6.19629H10.4132V20.6093Z",
    fill: "#FFBF4B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14Z",
    fill: "#EDEDED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99976 12.5005C10.0373 12.5005 12.4998 10.0381 12.4998 7.00049C12.4998 3.96292 10.0373 1.50049 6.99976 1.50049C3.96219 1.50049 1.49976 3.96292 1.49976 7.00049C1.49976 10.0381 3.96219 12.5005 6.99976 12.5005Z",
    fill: "#BCBCBC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.26082 3.71675L8.17386 5.54284C8.21734 5.6298 8.3043 5.69502 8.39125 5.71675L10.413 6.0211C10.6521 6.06458 10.7608 6.34719 10.5869 6.5211L9.13038 7.95589C9.06517 8.0211 9.02169 8.1298 9.04343 8.21676L9.39125 10.2385C9.43473 10.4776 9.17386 10.6733 8.95647 10.5428L7.15212 9.58632C7.06516 9.54284 6.95647 9.54284 6.86951 9.58632L5.04342 10.5428C4.82603 10.6515 4.56516 10.4776 4.60864 10.2385L4.95647 8.21676C4.97821 8.1298 4.93473 8.0211 4.86951 7.95589L3.41299 6.5211C3.23908 6.34719 3.32603 6.04284 3.5869 6.0211L5.60864 5.71675C5.6956 5.69502 5.78255 5.65154 5.82603 5.54284L6.73908 3.71675C6.84777 3.49936 7.15212 3.49936 7.26082 3.71675Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedalClub);
export default __webpack_public_path__ + "static/media/medal_club.8c75728c51bfaa401eeb4a980a3689f4.svg";
export { ForwardRef as ReactComponent };